<template>
  <div class="icon-content">
    <!-- 顶部图标 -->
    <img class="icon-tip" :src="appData.agentLogoUrl" />

    <!-- 宣传语 -->
    <div class="center-tip">少花钱 上好网</div>

    <!-- 设备输入区 -->
    <div class="center-content">
      <div class="center-top">
        <p>请绑定设备</p>
        <img class="img-style" src="@/assets/2025/trouble.png" @click="showAction" />
      </div>

      <div class="row-box">
        <div class="left-box">
          <div class="label">设备编号</div>
          <input class="input-style" type="text" placeholder="请输入设备编号" v-model="deviceSn"
            @blur="handleBlur('deviceSn', deviceSn)" />
        </div>

        <div class="rightScanContent">
          <img class="scan" src="@/assets/images/home/scan.png" alt="扫码" @click="enterScanAction" />
        </div>
      </div>

      <div class="row-box">
        <div class="left-box">
          <div class="label">登记手机号</div>

          <input class="input-style" type="tel" placeholder="请输入登记手机号" v-model="phone" />
        </div>
      </div>

      <div class="row-box">
        <div class="left-box">
          <div class="label">验证码</div>

          <input class="input-style" type="tel" placeholder="请输入验证码" v-model="smsCode" maxlength="11" />
        </div>

        <div class="right-box">
          <button class="get-code-button" @click="getCodeAction" :disabled="isCodeButtonDisabled">
            {{ isCodeButtonDisabled ? `${countdown}秒后重试` : "获取验证码" }}
          </button>
        </div>
      </div>
    </div>

    <!-- 提交按钮 -->
    <div class="buy-button" @click="addDeviceAction">提交</div>

    <van-overlay :show="show" @click="closeOverlay">
      <div class="wrapper">
        <div class="block" @click.stop>
          <p class="block-tip">请扫描设备条形码进行绑定激活</p>
          <img class="block-icon" src="@/assets/deviceCode.png" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {
  getDeviceInfo,
  addDevice,
  getCode,
  getWXAuthInfor,
  checkDevice,
  createLeaseFreeActivationDevice
} from "@/api/home";
import { Toast } from "vant";

export default {
  data() {
    return {
      // deviceType: "", //设备类型
      deviceSn: "", //设备编号
      deviceID: "", //设备ID
      phone: "", //手机号
      smsCode: "", //验证码
      isCodeButtonDisabled: false, //验证码按钮是否禁用
      countdown: 60, //倒计时
      smsNo: "", //短信流水
      skipPay: false, //是否跳过支付
      show: false,
    };
  },

  watch: {
    phone(newVal) {
      this.phone = newVal.replace(/\D/g, "").slice(0, 11); // 移除非数字字符，并限制长度
    },
    smsCode(newVal) {
      // 移除非数字字符
      const cleanValue = newVal.replace(/\D/g, "");
      //超过6位，检查是否有重复模式（
      if (cleanValue.length > 6) {
        const halfLength = Math.floor(cleanValue.length / 2);
        if (cleanValue.slice(0, halfLength) === cleanValue.slice(halfLength)) {
          // 如果检测到重复模式，只保留前半部分
          this.smsCode = cleanValue.slice(0, halfLength);
        } else {
          this.smsCode = cleanValue;
        }
      } else {
        this.smsCode = cleanValue;
      }
    },
  },

  mounted() {
    //配置微信授权
    this.uppdateWXConfigAction();
  },

  methods: {
    showAction() {
      this.show = true;
    },

    closeOverlay() {
      this.show = false;
    },
    ///授权
    uppdateWXConfigAction() {
      getWXAuthInfor().then((res) => {
        this.$wx.config({
          debug: false,
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.noncestr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: ["scanQRCode"], // 必填，随意一个接口即可
        });

        this.$wx.ready(() => {
          console.log("微信JS-SDK初始化成功");
        });

        this.$wx.error((err) => {
          console.error("wx.config 错误:", err);
        });
      });
    },

    ///扫一扫
    enterScanAction() {
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有 "qrCode"
        success: (res) => {
          console.log("res===============>", res);
          let resultStr = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          let barCode = resultStr.split(",");
          this.deviceSn = barCode[barCode.length - 1];
          this.getDeviceInfoAction();
        },
        fail: (res) => {
          Toast.fail("扫描失败");
        },
      });
    },

    handleBlur(field, value) {
      if (value) {
        console.log(value);
        this[field] = value;
        this.getDeviceInfoAction();
      }
    },

    // 获取设备信息
    getDeviceInfoAction() {
      checkDevice({
        sn: this.deviceSn,
      }).then((res) => {
        if (res) {
          this.deviceID = res.id;
          this.skipPay = res.skipPay;
        } else {
          this.deviceID = "";
        }
      });
    },

    addDeviceAction() {
      if (!this.deviceSn) {
        Toast.fail("请输入设备编号");
        return;
      }

      if (!this.phone) {
        Toast.fail("请输入手机号");
        return;
      }

      if (this.phone.length != 11) {
        Toast.fail("手机号格式有误，请重新输入");
        return;
      }
      if (!this.smsNo) {
        Toast.fail("请获取验证码");
        return;
      }
      if (!this.smsCode) {
        Toast.fail("请输入验证码");
        return;
      }

      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      addDevice({
        id: this.deviceID,
        smsNo: this.smsNo,
        smsCode: this.smsCode,
        skipPay: this.skipPay,
      }).then((res) => {
        // 跳转类型：1-用户激活，2-立即领取，3-缴纳押金
        let enterType = res.type;

        if (enterType === 2 || enterType === 3) {
          let description = res.description; //描述
          let theme = res.theme; //主题

          // 公共参数
          let url =
            "/home/deviceFree?enterType=" +
            enterType +
            "&description=" +
            description +
            "&theme=" +
            theme +
            "&terminalId=" +
            this.deviceID +
            "&sn=" +
            this.deviceSn + "&phone=" + this.phone;

          // type=3 时多带一个 depositAmount
          if (enterType === 3) {
            let depositAmount = res.depositAmount; //缴纳押金(元)
            url += "&depositAmount=" + depositAmount;
          }
          this.uni.navigateTo(url);
        } else if (enterType === 4) {


          Toast.loading({
            message: "设备激活中...",
            forbidClick: true,
          });
          createLeaseFreeActivationDevice({
            phone: this.phone,
            terminalId: this.deviceID,
          })
            .then((res) => {

              Toast.success("激活成功");
              this.$store.dispatch("updateDeviceID", this.deviceID);
              this.uni.navigateTo("/home/auth?sn=" + this.deviceSn + "&isFirst=1");
            });

        }
        else {
          this.uni.navigateTo(
            "/home/updateBuy?sn=" + this.deviceSn + "&isenterAuth=1" + "&phone=" + this.phone
          );
        }
      });
    },

    getCodeAction() {
      if (!this.deviceSn) {
        Toast.fail("请输入设备编号");
        return;
      }

      if (!this.phone) {
        Toast.fail("请输入手机号");
        return;
      }

      if (this.isCodeButtonDisabled) {
        return; // 如果按钮已禁用，直接返回
      }

      this.isCodeButtonDisabled = true;
      this.smsCode = ""; // 清空之前的验证码

      getCode({
        phone: this.phone,
        source: "BIND",
        sn: this.deviceSn,
      })
        .then((res) => {
          this.smsNo = res.flowId;
          Toast.success("验证码发送成功");
          this.startCountdown(60);
        })
        .catch(() => {
          this.isCodeButtonDisabled = false;
        });
    },

    startCountdown(seconds) {
      this.countdown = seconds;
      const interval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(interval);
          this.isCodeButtonDisabled = false;
          this.countdown = 60;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  .block {
    width: 550px;
    height: 550px;
    background-color: #fff;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 1001;

    .block-tip {
      font: 32px;
      color: #1d2129;
      font-weight: bold;
    }

    .block-icon {
      width: 444px;
      height: 366px;
    }
  }
}

.icon-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding-top: 126px;
  width: 100%;
  height: 100%;

  .icon-tip {
    width: 136px;
    height: 136px;
  }

  .center-tip {
    color: #333;
    font-size: 36px;
    font-weight: bold;
    margin-top: 30px;
    text-align: center;
  }

  .center-content {
    margin: 50px 0 200px;
    background-color: #fff;
    border-radius: 16px;
    width: calc(100vw - 64px);
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .center-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 32px;
    font-weight: bold;
    color: #000;

    .img-style {
      width: 40px;
      height: 40px;
    }
  }

  .row-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // border: 1px solid var(--line-color);
    border-radius: 8px;
    padding: 12px 20px;
    box-shadow: 0 4px 8px rgba(102, 102, 102, 0.15);
    height: 85px;
    margin-bottom: 30px;

    .left-box {
      flex: 1;
      display: flex;
      align-items: center;
      min-width: 0;

      .label {
        width: 180px;
        flex-shrink: 0;
        font-size: 32px;
        color: #1d2129;
      }

      .input-style {
        flex: 1;
        min-width: 0;
        height: 60px;
        padding: 0 10px;
        font-size: 32px;
        border: none;
        outline: none;

        &::placeholder {
          color: #9d9d9d;
        }
      }
    }

    .rightScanContent {
      flex-shrink: 0;

      .scan {
        width: 40px;
        height: 40px;
        cursor: pointer;
      }
    }

    .get-code-button {
      padding: 12px 16px;
      background-color: var(--primary-color);
      border: none;
      border-radius: 8px;
      color: #fff;
      font-size: 24px;
      white-space: nowrap;
    }
  }

  .buy-button {
    background-color: var(--primary-color);
    color: #fff;
    font-size: 32px;
    width: calc(100vw - 80px);
    height: 90px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    cursor: pointer;
    transition: opacity 0.2s ease;

    // &.disabled {
    //   opacity: 0.6;
    //   pointer-events: none;
    // }

    // &:active {
    //   opacity: 0.9;
    // }
  }
}
</style>
